import { ThemeColor } from '@/enums'
import { useFormContext, useFormItem } from '@/providers'
import { fromEventTarget, themeColorFrom } from '@/utils'
import { AutocompleteWithDropdown } from '@surein/ui'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import { getError } from './helpers'

const StyledMessage = styled.p<{ color: ThemeColor }>`
  cursor: inherit;
  white-space: pre-line;
  line-height: 140%;
  font-weight: 700;
  font-size: 12px;
  color: ${themeColorFrom(prop('color'))};
`

interface DropdownOption {
  value: string
  label: string
}

interface FormInputWithDropdownProps {
  name: string
  label?: string
  disabled?: boolean
  infoMessage?: string
  showErrorMessage?: boolean
  validateOnChange?: boolean
  options: DropdownOption[]
  onDropdownItemSelect: (option: DropdownOption) => void
  onSearchInput?: (input: string) => void
  dropDownOptions?: DropdownOption[]
  placeholder?: string
  [key: string]: any
}

export const FormInputWithDropdown = ({
  name,
  label,
  disabled,
  infoMessage,
  showErrorMessage = true,
  validateOnChange = false,
  ...props
}: FormInputWithDropdownProps) => {
  const { validateField } = useFormContext()
  const [touched, setIsTouched] = useState(false)
  const { value, onChange, error } = useFormItem(name)
  const errorMsg = getError(error)

  useEffect(() => {
    if (touched && validateOnChange && value) validateField(name)
  }, [validateOnChange, touched, value])

  const hasErrorMessage = errorMsg && showErrorMessage

  return (
    <div className="flex flex-col gap-2">
      <AutocompleteWithDropdown
        disabled={disabled}
        isErrored={Boolean(error)}
        label={label}
        name={name}
        onChange={fromEventTarget(onChange)}
        onFocus={() => setIsTouched(true)}
        value={value}
        {...props}
      />

      {hasErrorMessage && (
        <StyledMessage color={ThemeColor.danger2}>{errorMsg}</StyledMessage>
      )}

      {infoMessage && !hasErrorMessage && (
        <StyledMessage color={ThemeColor.b50}>{infoMessage}</StyledMessage>
      )}
    </div>
  )
}
